module.exports = __webpack_public_path__ + "img/step3.467fd67c.jpg";